import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';

import css from './TypeButtons.module.css';

const TypeButtons = ({ userTypeConfig, name, changeForm,showImages }) => {
  return (
    <Field name={name}>
      {({ input }) => (
        <div className={css.userTypeButtons}>
          {userTypeConfig.map(item => {
            const classes =
              input.value === item.key
                ? classNames(css.typeButtonActive, css.typeButton)
                : css.typeButton;
            return (
              <div
                className={classes}
                key={item.key}
                onClick={(e) => {
                  input.onChange(item.key);
                  changeForm(item.key);
                }}
              >
                {showImages&&<img src={item.image} className={css.typeButtonImage} alt={item.label} />}
                <span className={css.typeButtonLabel} style={!showImages?{color:'black',textShadow:'none'}:{}}>{item.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </Field>
  );
};

export default TypeButtons;
